import { useTranslation } from 'react-i18next';
import Reveal from './Reveal';
import './InfoPage.css';

// The plain pages of the site (FAQ, pricing, contact): a small label, the
// big italic title and a line underneath. The content can grow later; the
// look is settled.
function InfoPage({ ns, children }) {
  const { t } = useTranslation();

  return (
    <div className="info h-container">
      <Reveal as="p" className="h-label">
        {t(`${ns}.kicker`)}
      </Reveal>
      <Reveal as="h1" className="h-display info-title" delay={100}>
        {t(`${ns}.title`)}
      </Reveal>
      <Reveal as="p" className="info-body" delay={220}>
        {t(`${ns}.body`)}
      </Reveal>
      {children}
    </div>
  );
}

export default InfoPage;
